import { RedirectToAuthProps, redirectToAuth } from 'authorization-module'
import config from 'const/config'
import getApigeeClientId from 'helpers/getApigeeClientId'
import routes from 'const/routes'

const redirectToUniversalIDP = ({
  client,
  prompt,
  legacyClient,
  navigateTo,
  scope
}: {
  client: string
  prompt: string
  legacyClient?: string
  navigateTo?: string
  scope?: string
}) => {
  const apigeeClientId = getApigeeClientId(client)
  const redirectUri = `${window.location.origin}${config.BASENAME}${routes.CALLBACK}`

  const authParams: RedirectToAuthProps = {
    baseURL: config.AUTH_DOMAIN,
    clientId: apigeeClientId,
    redirectURI: redirectUri
  }

  if (prompt && prompt !== 'reauth') {
    authParams.prompt = prompt
  }

  if (legacyClient) {
    authParams.legacyClient = legacyClient
  }

  if (navigateTo) {
    authParams.navigateTo = navigateTo
  }

  if (scope) {
    authParams.scope = scope
  }

  redirectToAuth(authParams)
}

export default redirectToUniversalIDP
